import React, { useState } from 'react';
import moment from "moment";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import _ from "lodash";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import IconEditRecord from "src/assets/images/icon_editrecord.svg";
import IconManagerAllocate from "src/assets/images/icon_managerallocate.svg";

export const DepotPersonalDetailView = ({ handleBackButtonClick, setIsDeactivateDepotInfo, handleDeactiveAccountClick, handleEditDepotPersonnelClick, setEditTextFlag, setAllocateTogle, handleUnlistAccountClick, setIsFullDetails }) => {

      /** redux store useDispatch & useSelector ------------------------------ **/
      const { individualDepotPersonnelInfo } = useSelector((state) => state.depotUsers);
      const { signoutModelOpenFlag } = useSelector((state) => state.auth);

      /** Variable declarations ----------------------------------------------------- **/
      const allocatedDepotArray = _.filter(individualDepotPersonnelInfo?.depots, (d1) => d1.hasAllocated === true)

      /** handler functions--------------------------------------------------- **/

      /** Function executes when clicking on 'Edit Record' and saves the respective depot user info into the state ----------------------- **/
      const handleEditDepotPersonnel = () => {
            handleEditDepotPersonnelClick(individualDepotPersonnelInfo)
            setEditTextFlag(true);
      }

      /** Function to handle image errors --------------- **/
      const imgError = (image) => {
            image.onerror = "";
            image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
            return true;
      }

      /** Function for getting the allocated date whose allocate to one of the depot ---------------------- **/
      const showAllocatedDate = (data) => {
            var allocatedDate = _.find(data?.depots || [], d => d.hasAllocated)?.allocatedOn || null
            return allocatedDate ? moment(allocatedDate).format('DD-MMM-YYYY') : moment(data?.raisedOn).format('DD-MMM-YYYY')
      }

      /** Function executes when clicking on 'Deactivate Account --------------------- **/
      const handleDeactivateAccountClick = (item) => {
            handleDeactiveAccountClick();
            setIsDeactivateDepotInfo(item)
      };

      return <>
            <div className={`main-details-div-for-goodsin ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`}>
                  <div className="row">
                        <div className="d-flex justify-content-center first-row-details-goodsin-page" onClick={() => handleBackButtonClick()}>
                              <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
                                    <img src={IconLeftArrow} alt="left arrow" />
                              </div>
                        </div>

                        <div className="admin-details-subdiv-style">
                              <div className="edit-depot-perosonel-img-style">

                                    <img className="edit-record-depot-persoanl-img"
                                          src={individualDepotPersonnelInfo?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                                          onError={imgError}
                                          alt='Avtar'
                                    />
                              </div>

                              <div className="d-flex flex-row justify-content-between edit-depotheader align-items-center">
                                    <div className="depotname-section">
                                          {individualDepotPersonnelInfo?.firstName || ""} {individualDepotPersonnelInfo?.middleName} {individualDepotPersonnelInfo?.lastName || ""}
                                    </div>
                                    <div className="me-3">
                                          <span className="me-2 address-main-header-text">ACTIVE SINCE</span>
                                          <span className="address-subsection text-uppercase">{showAllocatedDate(individualDepotPersonnelInfo)}</span>
                                    </div>
                              </div>

                              <div className="add-space-margin-top-space">
                                    <div className="d-flex flex-column">
                                          <span className="address-main-header-text">ADDRESS</span>
                                          <div className="address-subsection">
                                                {individualDepotPersonnelInfo?.address?.street1 || ""}&nbsp;,
                                                {individualDepotPersonnelInfo?.address?.street2 || ""}
                                                {individualDepotPersonnelInfo?.address?.city || ""}&nbsp;,
                                                {individualDepotPersonnelInfo?.address?.state || ""}
                                                {individualDepotPersonnelInfo?.address?.country || ""}&nbsp;,
                                                {individualDepotPersonnelInfo?.address?.zip || ""}
                                                {individualDepotPersonnelInfo?.address?.plotNumber || ""}
                                          </div>
                                    </div>
                              </div>

                              <div className="add-space-margin-top-basic-details">
                                    <div className="d-flex space-header-section">
                                          <div className="d-flex flex-column col-md-6">
                                                <span className="address-main-header-text">EMAIL</span>
                                                <span className="address-subsection">{individualDepotPersonnelInfo?.email || ""}</span>
                                          </div>
                                          <div className="d-flex flex-column col-md-4">
                                                <span className="address-main-header-text">PHONE</span>
                                                <span className="address-subsection">{individualDepotPersonnelInfo?.phoneNumber || ""}</span>
                                          </div>
                                          <div className="d-flex flex-column col-md-2">
                                          </div>
                                    </div>
                              </div>

                              <div className="table-responsive edit-depot-personal-table">
                                    <table className="table table-borderless admintab-depots-details-table ">
                                          <thead className="depot-per-details-header-style">
                                                <tr>
                                                      <th scope="col">ALLOCATED AT</th>
                                                      <th scope="col">FROM</th>
                                                      <th scope="col">TO</th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {individualDepotPersonnelInfo?.roles?.includes("Admin") ?
                                                      <>
                                                            <tr className={`depots-tabdetails--body-style`}>
                                                                  <td className="text-uppercase">{moment(individualDepotPersonnelInfo?.raisedOn).format("DD-MMM-YYYY") || ""}</td>
                                                                  <td>On-going</td>
                                                                  <td className='add-color-for-admin'>ADMIN</td>
                                                            </tr>
                                                      </>
                                                      :
                                                      individualDepotPersonnelInfo?.depots?.map((item, index) => {
                                                            return (
                                                                  <React.Fragment key={index}>
                                                                        <tr className={`depots-tabdetails--body-style`}>
                                                                              <td>{item?.name || ""}</td>
                                                                              <td className="text-uppercase">{moment(item?.allocatedOn).format("DD-MMM-YYYY") || ""}</td>
                                                                              <td>
                                                                                    {(!item.deAllocatedOn || item.deAllocatedOn == "0001-01-01T00:00:00") ?
                                                                                          "On-going"
                                                                                          : moment(item?.deAllocatedOn).format("DD-MMM-YYYY")
                                                                                    }
                                                                              </td>
                                                                              <td>
                                                                                    {(!item.deAllocatedOn || item.deAllocatedOn == "0001-01-01T00:00:00") ?
                                                                                          <button variant="outlined" className="btn-bootstrap-submit-style-pm-remove-detail" style={{ color: "red", borderColor: "red", fontSize: 11 }} onClick={() => handleDeactivateAccountClick(item)}><img className='me-2' src={IconRemove} width={15} height={15} alt="new"></img>
                                                                                                REMOVE ALLOCATION
                                                                                          </button> : ""
                                                                                    }
                                                                              </td>
                                                                        </tr>
                                                                  </React.Fragment>
                                                            );
                                                      })}
                                          </tbody>
                                    </table>
                              </div>

                              <div style={{ height: 60 }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex">
                                                <div className="me-4">
                                                      {allocatedDepotArray.length > 0 ?
                                                            <Button
                                                                  variant="outlined"
                                                                  style={{ color: "red", borderColor: "red" }}
                                                                  startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>}
                                                                  onClick={() => { setIsFullDetails(true); handleDeactiveAccountClick() }}>
                                                                  DE-ACTIVATE ACCOUNT
                                                            </Button> :
                                                            <Button
                                                                  variant="outlined"
                                                                  style={{ color: "red", borderColor: "red" }}
                                                                  startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>}
                                                                  onClick={handleUnlistAccountClick}>
                                                                  UNLIST ACCOUNT
                                                            </Button>
                                                      }
                                                      {/* {allocatedDepotArray.length > 0 ?
                                                           "" :
                                                            <Button variant="outlined" style={{ color: "red", borderColor: "red" }} startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>} onClick={handleUnlistAccountClick}>
                                                                  UNLIST ACCOUNT
                                                            </Button>
                                                      } */}
                                                </div>

                                                <div>
                                                      <Button variant="outlined" className="submit-btn-style" startIcon={<img src={IconEditRecord} width={17} height={17} alt="new"></img>} onClick={() => handleEditDepotPersonnel()}>
                                                            EDIT RECORD
                                                      </Button>
                                                </div>
                                          </div>
                                          {individualDepotPersonnelInfo?.roles?.includes("Admin") ? "" :
                                                <Button variant="outlined" className="submit-btn-style" startIcon={<img src={IconManagerAllocate} width={17} height={17} alt="new"></img>} onClick={() => setAllocateTogle()}>
                                                      ALLOCATE DEPOT
                                                </Button>
                                          }
                                    </div>

                              </div>


                        </div>

                        <div className=" first-row-details-goodsin-page">
                        </div>


                  </div>
            </div>


      </>;
};